import { useState } from 'react';
import { testimonials } from '@/mocks/home-data';

export default function TestimonialSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const current = testimonials[activeIndex];

  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="relative max-w-5xl mx-auto">
          <div className="hidden lg:block absolute -top-8 -left-8">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" className="text-secondary-700/30">
              <path d="M12 4C8 8 4 16 4 24C4 36 10 44 20 48C24 48 28 44 28 38C28 32 24 28 18 28C16 28 14 28.5 12 29.5C14 22 18 16 24 12L12 4Z" fill="currentColor"/>
              <path d="M48 4C44 8 40 16 40 24C40 36 46 44 56 48C60 48 64 44 64 38C64 32 60 28 54 28C52 28 50 28.5 48 29.5C50 22 54 16 60 12L48 4Z" fill="currentColor"/>
            </svg>
          </div>

          <div className="bg-secondary-950 rounded-2xl overflow-hidden">
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-[38%] relative">
                <div className="h-[320px] lg:h-[450px] overflow-hidden">
                  <img
                    src={current.avatar}
                    alt={current.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/60 via-transparent to-transparent lg:bg-gradient-to-r lg:from-secondary-950/80 lg:via-secondary-950/30 lg:to-transparent" />
              </div>

              <div className="lg:w-[62%] flex flex-col justify-center px-6 md:px-10 py-8 md:py-10">
                <span className="text-5xl md:text-6xl text-accent-400/30 leading-none select-none">&ldquo;</span>
                <p className="text-base md:text-lg text-background-50/90 leading-relaxed -mt-4">
                  {current.content}
                </p>
                <div className="mt-6">
                  <p className="text-background-50 font-heading font-bold text-sm">{current.name}</p>
                  <p className="text-background-50/40 text-xs mt-0.5">{current.role}</p>
                </div>

                <div className="flex items-center gap-3 mt-8">
                  {testimonials.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setActiveIndex(index)}
                      className={`w-10 h-10 rounded-full flex items-center justify-center text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
                        index === activeIndex
                          ? 'bg-accent-400 text-foreground-950'
                          : 'bg-background-50/10 text-background-50/50 hover:bg-background-50/20'
                      }`}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}